import getUrlParam from './getUrlParam';

console.info(`[LOAD][SIGNUP] %cscripts/utils/signup.js`, LOG.style.muted);

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const resetFormSetup = () => {
    var n1 = Math.round(Math.random() * 10 + 1);
    var n2 = Math.round(Math.random() * 10 + 1);

    var $resetPswForm = $('#recover_customer_password form');
    
    $resetPswForm.find("#question").text(n1 + " + " + n2);

    $resetPswForm.attr('action', $resetPswForm.data('action'));
    $resetPswForm.find('input[type="submit"]').prop('disabled', false);

    $resetPswForm.off('submit').on( 'submit', (e) => {
        if($resetPswForm.find('input.checker').val() != '' || $resetPswForm.find('input#field-email-real').val() != ''){
            e.preventDefault();
            return false;
        }
        if($resetPswForm.find('input#field-email').val() == '' || !validateEmail($resetPswForm.find('input#field-email').val())){
            e.preventDefault();
            $resetPswForm.find('input#field-email').parents('.form-row').addClass('error-field');
            return false;
        }
        if(window.showChallenge) {
            if(eval($resetPswForm.find("#question").text()) != $resetPswForm.find("#answer").val()) {
                $resetPswForm.find(".form-row.controler").addClass('error-field');
                e.preventDefault();
                return false;
            }
        }
    });
};

const createAccountFormSetup = () => {
    var n1 = Math.round(Math.random() * 10 + 1);
    var n2 = Math.round(Math.random() * 10 + 1);

    var $form = $('#create_customer');

    const originalUrl = window.localStorage.getItem('original-href');
    if(originalUrl) {
        $('input[name="return_to"]').val(originalUrl);
    }
    
    $form.find("#question").text(n1 + " + " + n2);

    $form.attr('action', $form.data('action'));
    $form.find('input[type="submit"]').prop('disabled', false);
};

const signupPopup = () => $(document).on('page:ready', () => {

    console.info(`[EVENT][SIGNUP] %cpage:ready`, LOG.style.muted)

    const $form = $('#create_customer');
    const $signUpTab = $('#sign-up-tab');
    const $signInTab = $('#sign-in-tab');
    const $showSignInTab = $('#show-sign-in');
    const $showSignUpTab = $('#show-sign-up');
    const $resetPageF = $('#reset-page-f');
    const $passordReset = $('#pass-reset-btn');
    const $cancelResetPwd = $('#cancel-reset-pwd');
    const $emailSection = $('#email_done');
    const $emailInput = $form.find('input[type="email"]');
    const $passwordSection = $('#password_done');
    const $logincusbtn = $('#login-cus-btn');
    const $passwordInput = $form.find('input[type="password"]');
    const lastEmailUsed = localStorage.getItem('last-email-used');
    const checkout_url = localStorage.getItem('ori-hide-href');
    const togoUrl = localStorage.getItem('hide-href');
    let removeHref = true;
    window.localStorage.removeItem('sociallogin');

    setTimeout(() => {
        $('.h_google_button').on('click', () => {
            localStorage.setItem('sociallogin', 'true');
        });
        $('.h_facebook_button').on('click', () => {
            localStorage.setItem('sociallogin', 'true');
        });
        $('.h_apple_button').on('click', () => {
            localStorage.setItem('sociallogin', 'true');
        });
    }, 5000);

    if(lastEmailUsed) {
        $('input[name="customer[email]"]').val(lastEmailUsed);
        $('input[name="customer[email]"]').trigger('change');
        $('input[name="customer[email]"]').trigger('blur');
    }

    if(checkout_url) {
        if(!togoUrl) {
            $('#checkout_url').val(checkout_url);
            localStorage.setItem('hide-href', checkout_url);
            removeHref = true;
        } else {
            removeHref = false;
            $('#checkout_url').val(togoUrl);
        }
    }

    $showSignInTab.off('click').click(function (e) {
        $signInTab.fadeIn();
        $signUpTab.hide();
    });

    $showSignUpTab.off('click').click(function (e) {
        $signInTab.hide()
        $signUpTab.fadeIn();
    });

    $resetPageF.off('click').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.reset-succeed').hide();
        $('#login-page-default').fadeIn();
    });

    $logincusbtn.off('click').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        const signInForm = $(e.currentTarget).closest('form');
        const $passwordInput = signInForm.find('#field-password');
        const $emailInput = signInForm.find('#field-email');
        let userPassword = $passwordInput.val();
        let userEmail = $emailInput.val();
        $passwordInput.removeClass('form_error');
        $emailInput.removeClass('form_error');
        if(removeHref) {
            localStorage.removeItem('hide-href');
        }
        if(!userPassword || userPassword.length < 4){
            $passwordInput.addClass('form_error');
            return false;
        } else {
            if(!userEmail || userEmail.length < 4 || !validateEmail(userEmail)) {
                $emailInput.addClass('form_error');
                return false;
            } else {
                localStorage.setItem('last-email-used', userEmail);
                signInForm.submit();
            }
        }
    })

    $passordReset.off('click').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.popup-login-box').hide();
        $('.popup-reset-pwd-box').fadeIn();

        const lastAttempt = window.localStorage.getItem('last_c_attemp');
        window.showChallenge = false;
        if(lastAttempt) {
            const lastAttempObj = JSON.parse(lastAttempt);
            const now = (new Date()).getTime();
            const FIVE_MIN = 5*60*1000;
            if(now - lastAttempObj.time < FIVE_MIN && lastAttempObj.tries > 5) {
                window.showChallenge = true;
                $('#pwd-reset-challenge').show();
            } else {
                $('#pwd-reset-challenge').hide();
            }
        }
        resetFormSetup();
    });

    $cancelResetPwd.off('click').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.popup-reset-pwd-box').hide();
        $('.popup-login-box').fadeIn();
    });

    $emailSection.click(function(e) {
        const lastAttempt = window.localStorage.getItem('last_c_attemp');
        window.showChallenge = false;
        if(lastAttempt) {
            const lastAttempObj = JSON.parse(lastAttempt);
            const FIVE_MIN = 5*60*1000;
            const now = (new Date()).getTime();
            if(now - lastAttempObj.time < FIVE_MIN && lastAttempObj.tries > 5) {
                window.showChallenge = true;
            }
            window.localStorage.setItem('last_c_attemp', JSON.stringify({ time: now, tries: lastAttempObj.tries + 1 }));
        } else {
            const now = (new Date()).getTime();
            window.localStorage.setItem('last_c_attemp', JSON.stringify({ time: now, tries: 1 }));
        }
        e.preventDefault();
        if(window.showChallenge) {
            $emailSection.hide();
            let userEmail = $emailInput.val();
            $emailInput.removeClass('form_error');
            if(userEmail.length === 0){
                $emailInput.addClass('form_error');
                return false;
            }
            if(!validateEmail(userEmail)){
                $emailInput.addClass('form_error');
                alert('Invalid Email');
                return false;
            }
    
            $('.form_password_area').removeClass('hide_form');
        } else {
            let userEmail = $emailInput.val();
            $emailInput.removeClass('form_error');
            if(userEmail.length === 0 || !validateEmail(userEmail)){
                $emailInput.addClass('form_error');
                return false;
            }
            let userPassword = $passwordInput.val();
            $passwordInput.removeClass('form_error');
            $('#error-field-password').hide();
            if(userPassword.length < 8 || !/[A-Z]/.test(userPassword)){
                $passwordInput.addClass('form_error');
                $('#error-field-password').show();
                return false;
            }
            $passwordSection.trigger('click');
        }
    });
    
    $passwordSection.click(function(e){
        e.preventDefault();
        let userPassword = $passwordInput.val();
        $passwordInput.removeClass('form_error');
        $('#error-field-password').hide();
        if(userPassword.length < 8 || !/[A-Z]/.test(userPassword)){
            $passwordInput.addClass('form_error');
            $('#error-field-password').show();
            return false;
        } else {
            if($('#field-email').val()) {
                Inspira.globals.customerName = $('#create_customer #field-email').val();
            }
            $form.trigger('submit');
        }
    });
    createAccountFormSetup();
});


/*
@Info: 
Function to save and redirect a checkout url when a user is directed to a signup form.
This is a scenario that happens with draft orders.
*/
const signupDraftOrders = () => {
    const query = getUrlParam(document.location.search);
    const checkoutUrl = query.checkout_url;

    if (!Inspira.globals.customerId) {
        if (checkoutUrl) {
            localStorage.checkoutUrl = checkoutUrl;
        }
        return false;
    }

    if (localStorage.checkoutUrl) {
        let checkout_url = localStorage.checkoutUrl;
        localStorage.removeItem("checkoutUrl");
        window.location.href = decodeURIComponent(checkout_url);
    }
}

const signup = {
    signupPopup,
    signupDraftOrders,
    createAccountFormSetup,
    resetFormSetup
}

export default signup;
